module.exports = __webpack_public_path__ + "img/banner2-min.1ea84d43.png";